import { BucketIdentifier, S3File } from "@dune/types";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { S3FileInput } from "../common/S3FileInput";

interface ControlledS3FileInputProps<T extends FieldValues> {
	name: FieldPath<T>;
	control: Control<T>;
	bucket: BucketIdentifier;
	label?: string;
	initialFile?: S3File;
	onPreview?: (file: S3File) => void;
	onRemove?: () => void;
}

const ControlledS3FileInput = <T extends FieldValues>({
	name,
	control,
	bucket,
	label,
	initialFile,
	onRemove,
	onPreview,
}: ControlledS3FileInputProps<T>) => {
	return (
		<div className="space-y-2 w-full">
			{label && <div>{label}</div>}
			<Controller
				name={name}
				control={control}
				render={({ field }) => (
					<S3FileInput
						bucket={bucket}
						initialFile={initialFile}
						onRemove={onRemove}
						onUploadSuccess={(s3File: S3File) =>
							field.onChange({
								name: s3File.name,
								bucket: s3File.bucket,
								key: s3File.key,
								type: s3File.type,
								size: s3File.size,
							})
						}
						onPreview={onPreview}
					/>
				)}
			/>
		</div>
	);
};

export { ControlledS3FileInput };
